import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetConfirmEmailByHashQuery } from "../../api/invitedAdmins";
import { CircularProgress } from "@mui/material";
import { TiWarning } from "react-icons/ti";
import logo from "../../images/logo-name_dark.svg";
import emailIcon from "../../images/confirmation_email.svg";
import "./style.confirmation.scss";

const Confirmation = () => {
  const [isConfirmError, setIsConfirmError] = useState(false);
  const [username, setUsername] = useState("");
  const { hash } = useParams();

  const { data, error, isLoading } = useGetConfirmEmailByHashQuery({ hash }, {
    skip: !hash,
  });

  useEffect(() => {
    if (!isLoading) {
      if (error) {
        setIsConfirmError(error.data && error.data.message);
      } else {
        setUsername(data.email);
      }
    }
  }, [data, error, isLoading]);

  const handleContinue = () => {
    // This logic attempts to open the app via deep link, 
    // falling back to the web URL if the app isn't installed.
    setTimeout(() => {
      window.location.href = "https://shift.dev.api-bettertrucks.com/splash";
    }, 500);
  };

  return (
    <div className="confirmation-page">
      <div className="confirmation-card">
        <header className="confirmation-header">
          <img src={logo} alt="Better Trucks Logo" className="brand-logo" />
        </header>

        {isLoading ? (
          <div className="confirmation-status-view">
            <CircularProgress size={60} thickness={4} />
            <p>Verifying your account...</p>
          </div>
        ) : isConfirmError ? (
          <div className="confirmation-status-view">
            <div className="icon-wrapper error">
              <TiWarning size={60} />
            </div>
            <h2 className="title">Confirmation Failed</h2>
            <p className="description">{isConfirmError}</p>
            <button onClick={handleContinue} className="action-btn">
              Back to App
            </button>
          </div>
        ) : (
          <div className="confirmation-status-view">
            <div className="icon-wrapper">
              <img src={emailIcon} alt="Email Verified" />
            </div>

            <h1 className="title">Your email has been confirmed</h1>

            <div className="email-badge">
              <span>{username || "your-email@example.com"}</span>
            </div>

            <p className="description">
              Thanks for verifying your email address. You can now continue your onboarding 
              and complete the remaining steps to start driving with us.
            </p>

            <button onClick={handleContinue} className="action-btn">
              Continue to Shift App
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Confirmation;